module.exports = __webpack_public_path__ + "static/media/bg-movie.dfaa048c.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg-movie.mp4
// module id = 364
// module chunks = 0